import { render, staticRenderFns } from "./Artigo.vue?vue&type=template&id=25256700&"
import script from "./Artigo.vue?vue&type=script&lang=js&"
export * from "./Artigo.vue?vue&type=script&lang=js&"
import style0 from "./Artigo.vue?vue&type=style&index=0&id=25256700&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports